module.exports = __webpack_public_path__ + "images/sms-finance-10f26b92.png";